import useAddressVerification from '../../CheckoutPage/AddressVerification/useAddressVerification';
import useUserExists from '../../CheckoutPage/OrderContactInfo/useUserExists';

const useCallbackFunctionMap = () => {
  const { triggerAddressVerification } = useAddressVerification();
  const { triggerUserExists } = useUserExists();
  const callbackFuncionMap = {
    triggerAddressVerification,
    triggerUserExists,
  };
  return callbackFuncionMap;
};

export default useCallbackFunctionMap;
